<template>
  <preloader-overlay :loading="loading">
    <div :class="$style.container">

      <div :class="$style.header">
        <responsive-controller>
          <template #tablet>
            <screen-header
              :title="$t('wallet.select.header.title')"
              :history-mode="false"
              @navigate="handleNavigate"
            />
          </template>
          <template #default>
            <div>
              <navigate-button
                v-absolute
                v-left="-80"
                @navigate="handleNavigate"
              />
              <screen-title
                :title="$t('wallet.select.header.title')"
              />
            </div>
          </template>
        </responsive-controller>
      </div>

      <div :class="$style.content">
        <selectable-wallet-panel
          v-for="(wallet, idx) in getWalletList"
          :key="idx"
          v-m-b="20"
          :wallet="wallet"
          @click="handleChange(wallet)"
        />
        <adding-new-panel
          :message="$t('wallet.select.binding.button')"
          @click="$router.push({ name: 'wallet.binding' })"
        />
      </div>
    </div>
  </preloader-overlay>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import ScreenTitle from 'molecules/screen/ScreenTitle';
import ScreenHeader from 'molecules/screen/ScreenHeader';
import NavigateButton from 'molecules/common/NavigateButton';
import PreloaderOverlay from 'molecules/common/PreloaderOverlay';
import AddingNewPanel from 'molecules/panels/AddingNewPanel';

import SelectableWalletPanel from 'organisms/wallet/SelectableWalletPanel';

export default {
  name: 'WalletSelect',
  components: {
    ScreenTitle,
    ScreenHeader,
    NavigateButton,
    PreloaderOverlay,
    AddingNewPanel,
    SelectableWalletPanel,
  },
  created() {
    this.initialize();
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapGetters([
      'isCurrencyCrypto',
    ]),
    ...mapGetters('wallet', [
      'getWalletList',
      'isEmptyWalletList',
      'isNoLinkedWallet',
      // TODO: @danealton add isLinkedWalletInBlacklisted
    ]),
  },
  methods: {
    async initialize() {
      this.loading = true;

      if (!this.isCurrencyCrypto) {
        this.$router.push({ name: 'cardSelect' });
        return;
      }

      await this.fetchWalletList();

      this.loading = false;
    },
    handleNavigate() {
      if (this.isEmptyWalletList || this.isNoLinkedWallet) { // TODO: @danealton check to isLinkedWalletInBlacklisted
        this.$router.push({ name: 'cabinet' });
      } else {
        this.$router.push({ name: 'payout' });
      }
    },
    async handleChange(wallet) {
      this.loading = true;

      try {
        const data = await this.changeWallet(wallet);

        if (data.status === 'WALLET_SWITCHED') {
          this.$alert({
            type: 'success',
            text: 'wallet.select.request.success',
          });

          this.$router.push({ name: 'payout' });
          this.loading = false;
          return;
        }

        this.$router.push({ name: 'cardSelectedMessage' });
      } catch (error) {
        this.loading = false;

        this.$alert({
          type: 'warning',
          text: 'problems.with.server',
        });
      }
    },
    ...mapActions('wallet', [
      'fetchWalletList',
      'changeWallet',
    ]),
  },
};
</script>

<style lang="sass" module>
  .container
    +size(100%, auto)
    max-width: 500px
    margin: 0 auto
    padding: 20px 0 60px

    +responsive('large')
      padding: 60px 0

  .header
    position: relative
    margin-bottom: 20px
    padding: 0 20px

    +respond-to('small')
      padding: 0

  .content
    +base-sub-mount
    margin-bottom: 20px
</style>
